import { async, resolve } from "q";
import CommonService from "../src/services/commonService";
import InventoryService from "../src/services/inventoryService";

export const SuppliersMixin = {
	data() {
		return {
			vendors: [],
			applicableToAllStores: "all",
			scheduleOrder: [],
			locations: [],
			isDefault: "false",
			locationsSelected: [],
			suppliers: [],
			users: [],
			deliveryETA: null,
			approvedBy: "",
			showTable: false,
			showAddProduct: false,
			showUploadeCsv: false,
			supplier: "",
			orderCreatedBy: "",
			approveOrderTime: "",
			approvalRequired: "false",
			autoApproval: "false",
			products: []
		};
	},
	created() {
		// this.getLocations({ get_all: true });
		// this.getUsers({
		// 	get_all: true,
		// 	fields: ["id", "first_name", "last_name"]
		// });
		// this.getSuppliers({
		// 	//type should not be a store user
		// 	get_all: true,
		// 	type: "vendor"
		// });
		// this.getSupplireName({ get_all: true, type: "vendor" });
	},
	methods: {
		async deleteArticle(index) {
			this.$confirm("Are you sure to delete?")
				.then(_ => {
					this.products.splice(index, 1);
				})
				.catch(_ => {});
		},

		async getVendors() {
			try {
				this.vendors = await InventoryService.getVendors({
					fields: ["id", "account", "account_info", "type"],
					get_all: true
				}).then(response => {
					return JSON.parse(response.data);
				});
			} catch (err) {
				console.log(err);
			}
		},
		async getLocations(args) {
			this.locations = await this.getAllOutlets(args).then(response =>
				resolve(response)
			);
		},
		async getSuppliers(args) {
			this.suppliers = await this.getAllOutlets(args).then(response =>
				resolve(response)
			);
		},
		async getUsers(args) {
			this.users = await CommonService.getUsers(args).then(response => {
				console.log(JSON.parse(response.data));
				return resolve(JSON.parse(response.data));
			});
		},
		async getAllOutlets(args) {
			try {
				var prop = await CommonService.getOutlets(args).then(response => {
					return resolve(JSON.parse(response.data));
				});
			} catch (err) {
				console.log(err);
			}
			return prop;
		},
		createVendor(args) {
			return InventoryService.createVendor(args).catch(err => console.log(err));
		},
		createVendorSupplies(args) {
			return InventoryService.createVendorSupplies(args);
		}
	}
};
